import React from 'react';
import { FaCloud, FaMobileAlt, FaPlug, FaTabletAlt } from 'react-icons/fa';

const services = [
  { icon: FaMobileAlt, title: 'Flutter development', description: 'Cross-platform application development with Flutter and Dart.' },
  { icon: FaTabletAlt, title: 'Mobile app development', description: 'Responsive mobile experiences for practical product ideas.' },
  { icon: FaCloud, title: 'Firebase integration', description: 'Authentication, Firestore, messaging, and storage integrations.' },
  { icon: FaPlug, title: 'API integration', description: 'REST APIs and communication services connected to app workflows.' },
];

export default function Services() {
  return (
    <section className="border-y border-slate-800/70 px-4 py-16 sm:px-6 sm:py-24 lg:px-8" id="services">
      <div className="site-container">
        <div className="mb-8 max-w-2xl sm:mb-12">
          <p className="section-eyebrow">What I build</p>
          <h2 className="mt-5 text-3xl font-extrabold tracking-tight text-white sm:text-5xl">Focused development support.</h2>
        </div>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {services.map(({ icon: Icon, title, description }) => (
            <article key={title} className="surface-card group p-5 transition hover:-translate-y-1 hover:border-slate-500">
              <Icon className="text-cyan-300 transition group-hover:text-indigo-300" aria-hidden="true" />
              <h3 className="mt-5 text-base font-bold text-white">{title}</h3>
              <p className="mt-2 text-sm leading-6 text-slate-500">{description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
